<script lang="ts">
    export let label: string = 'Loading';
</script>

<div class="loading-state" aria-live="polite" aria-busy="true">
    <i class="spinner loading icon" aria-hidden="true"></i>
    <p class="loading-text">{label}…</p>
</div>

<style>
    .loading-state {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 320px;
        padding: var(--space-10) var(--space-5);
        gap: var(--space-4);
        color: var(--grey-secondary);
    }

    .loading-state :global(i.icon) {
        font-size: 2.5rem;
        color: var(--primary);
    }

    .loading-text {
        margin: 0;
        font-size: var(--text-base);
        color: var(--grey-secondary);
    }
</style>
